"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getArrIndexValue = exports.tcn = exports.generateChecksum = exports.stripExtension = exports.isBlank = void 0;
const sha_1 = require("./sha");
function isBlank(str) {
    return !str || /^\s*$/.test(str);
}
exports.isBlank = isBlank;
function stripExtension(name, ext) {
    const index = name.indexOf(ext);
    if (index >= 0) {
        name = name.slice(0, index);
    }
    return name;
}
exports.stripExtension = stripExtension;
/** TODO: shim for IE11 support */
// export async function generateChecksum(txt: string) {
//   //eslint-disable-next-line
//   const crypto = window.crypto || (window as any).msCrypto;
//   const data = new TextEncoder().encode(txt);
//   return Array.from(new Uint8Array(await crypto.subtle.digest('sha-256', data)))
//     .map(b => b.toString(16).padStart(2, '0'))
//     .join('');
// }
/**
 *
 * @param txt
 * @returns string
 *
 * We're going to use this currently until we decide how to proceed
 * using Promises, async/await, or Rx (or one of each for frameworks).
 */
function generateChecksum(txt) {
    //eslint-disable-next-line
    return sha_1.Sha256.hash(txt);
}
exports.generateChecksum = generateChecksum;
function convertToMathString(str) {
    return str
        .replace(/[\t\r\n\v\f\-\\\]!"#$%&'()*+,./:;<=>?@[^_`{|}~ 0a-zA-Z]|^(?![\s\S])/gi, '+9')
        .replace(/\+{2,}/gi, '+')
        .replace(/^\+*|\+*$|[^\d+]/gi, '');
}
function tcn(txt) {
    let ret = 1;
    try {
        if (txt === undefined || txt === null) {
            txt = '';
        }
        const myOp = convertToMathString(txt).split(/\+/) || [];
        let total = 0;
        myOp.forEach(v => {
            total += parseInt(v);
        });
        switch (total % 3) {
            case 1: {
                const newExpression = `${`${total}`.split('').join('+')}`;
                const myPlus = newExpression.split(/\+/) || [];
                let plusTotal = total;
                myPlus.forEach(v => (plusTotal += induceNumber(v)));
                ret = plusTotal;
                break;
            }
            case 2: {
                const newExpression = `${`${total}`.split('').join('-')}`;
                const myMinus = newExpression.split(/-/) || [];
                let minusTotal = total;
                myMinus.forEach(v => (minusTotal -= induceNumber(v)));
                ret = minusTotal;
                break;
            }
            default: {
                ret = total;
            }
        }
    }
    catch (err) {
        ret = -1;
    }
    return ret + '';
}
exports.tcn = tcn;
function induceNumber(a) {
    if (isNaN(a)) {
        return 0;
    }
    return parseInt(a);
}
//eslint-disable-next-line
function getArrIndexValue(arr, ind) {
    if (arr && typeof arr !== 'undefined' && arr.length > ind) {
        return arr[ind];
    }
    return ``;
}
exports.getArrIndexValue = getArrIndexValue;
//# sourceMappingURL=utils.js.map